import { SearchResultTypeEnum } from "@_types/modules";
import { z, ZodBoolean, ZodNullable, ZodNumber, ZodOptional, ZodString } from "zod";
import { DateSchema, DateStringSchema } from "./date";

export const UUID = z.string().uuid();

export const CreatedAt = DateSchema.nullish();

export const UpdatedAt = DateSchema.nullish();

export const PublishedAt = DateSchema.nullish();

export const PublishedAtString = DateStringSchema.nullish();

export const DeletedAt = DateSchema.transform(value => value ?? null);

export const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

export type Meta = Record<"page" | "pages" | "pageSize" | "total", number>;

export type PaginationType = {
  page?: number;
  pages?: number;
  pageSize?: number;
  total?: number;
};

export type SearchParams = {
  search: string;
};

export type PlayerParams = {
  studentUuid?: string;
};

export type SearchResults = {
  uuid: string;
  moduleUuid: string;
  name: string;
  type: SearchResultTypeEnum;
  order: number;
  moduleOrder: number | null;
  publishDate: string;
  available: boolean;
};

export const SelectOptionsSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const getPaginationParams = <T extends string = string>(
  zodObject: Record<T, ZodOptional<ZodNullable<ZodString | ZodBoolean | ZodNumber>>>
) =>
  z
    .object({
      page: z.number().nullish(),
      pageSize: z.number().nullish(),
    })
    .merge(z.object(zodObject))
    .nullish()
    .default(null);

export interface Filter {
  field: string;
  value: string;
  label: string;
}

export interface FilterActions<T> {
  addFilter: (filter: T) => void;
  removeFilter: (index: number) => void;
  removeFilterByName: (field: string) => void;
  clearFilters: () => void;
  filterToParams: () => void;
  getFilter: (field: string) => T | undefined;
}

export const UrlSchema = z.string().url();

export const InputSchema = z.string().trim().min(3);
